export function AppSingletonPromise(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
  const method = descriptor.value;
  descriptor.value = function(...args: any[]) {
    const force = args.length && !!args[0];
    const promises = ((this as any).singletonPromises = (this as any).singletonPromises || {});
    if (force || !promises[propertyKey]) {
      const promise = (promises[propertyKey] = method.apply(this, args).then((response: any) => {
        if (promises[propertyKey] !== promise) {
          throw new Error('request reissued');
        }
        return response;
      }));
      promise.finally(() => {
        if (promise === promises[propertyKey]) {
          delete promises[propertyKey];
        }
      });
    }
    return promises[propertyKey];
  };
}
